import { useLayoutEffect, useRef, useState } from "react"
import { marqueeConfig, marqueeCoverUrls } from "../data/marquee-covers-data"

export function useMarqueeAnimation(speed: number, repeatCount: number) {
  const marqueeRef = useRef<HTMLDivElement>(null)
  const firstSetWidthRef = useRef(0)
  const [coverHeight, setCoverHeight] = useState(marqueeConfig.defaultCoverHeight)

  useLayoutEffect(() => {
    if (!marqueeRef.current) return

    // Inject universal keyframes once
    const { keyframesName, styleId } = marqueeConfig
    if (!document.getElementById(styleId)) {
      const style = document.createElement("style")
      style.id = styleId
      style.textContent = `@keyframes ${keyframesName} { 0% { transform: translate3d(0,0,0); } 100% { transform: translate3d(-50%,0,0); } }`
      document.head.appendChild(style)
    }

    function measure() {
      if (!marqueeRef.current) return
      const firstImg = marqueeRef.current.querySelector("img") as HTMLImageElement | null
      const cardWidth = firstImg ? firstImg.offsetWidth + 8 /*mr-2*/ : 80
      const singleSetWidth = cardWidth * marqueeCoverUrls.length * repeatCount

      firstSetWidthRef.current = singleSetWidth

      // Duration = distance / speed (px/s)
      const duration = singleSetWidth / speed
      const el = marqueeRef.current
      if (el) {
        el.style.animation = `${keyframesName} ${duration}s linear infinite`
        el.style.willChange = "transform"
      }

      // Measure cover height for layout spacing
      if (firstImg) setCoverHeight(firstImg.offsetHeight)
    }

    // Initial measure
    measure()

    // Re-measure on resize (layouts change)
    window.addEventListener("resize", measure)

    return () => {
      window.removeEventListener("resize", measure)
    }
  }, [speed, repeatCount])

  return { marqueeRef, coverHeight }
}
